import { motion } from 'framer-motion';
import { PAGE_HERO } from '../../constants/testIds';

/**
 * Reusable page hero for inner pages.
 * Compact (not full viewport), brand-forest background, eyebrow + title + intro.
 */
export const PageHero = ({ eyebrow, title, intro, image, align = 'left' }) => {
  return (
    <section
      data-testid={PAGE_HERO.root}
      className="relative w-full bg-[#18342A] text-[#F5F1E8] overflow-hidden grain-overlay"
    >
      {image && (
        <div className="absolute inset-0 z-0">
          <img src={image} alt="" className="w-full h-full object-cover opacity-40" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#18342A]/60 via-[#18342A]/70 to-[#18342A]" />
        </div>
      )}

      <div className="relative z-10 pt-40 lg:pt-44 pb-20 lg:pb-28 px-6 md:px-10 lg:px-16 max-w-[1500px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className={align === 'center' ? 'text-center mx-auto max-w-3xl' : 'max-w-3xl'}
        >
          {eyebrow && (
            <div className={`flex items-center gap-4 mb-6 ${align === 'center' ? 'justify-center' : ''}`}>
              <span className="w-10 h-px bg-[#C9A458]" />
              <span className="text-[11px] tracking-[0.4em] uppercase text-[#C9A458]">
                {eyebrow}
              </span>
              {align === 'center' && <span className="w-10 h-px bg-[#C9A458]" />}
            </div>
          )}
          <h1 className="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-[96px] leading-[0.98] tracking-tight font-light">
            {title}
          </h1>
          {intro && (
            <p className="mt-8 text-[#F5F1E8]/80 text-base md:text-lg leading-relaxed font-light max-w-2xl">
              {intro}
            </p>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default PageHero;
